/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * A React component for Audio Volume High Icon.
 *
 * @author Ramani Govindaraju
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const NavAudioHigh = props => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h18v18H0z" />
      <path
        fill="#252525"
        d="M3.673 12H1.5A1.5 1.5 0 0 1 0 10.5v-3A1.5 1.5 0 0 1 1.5 6h2.084L7.72 1.876A.75.75
        0 0 1 9 2.407V15.59a.75.75 0 0 1-1.285.525L3.673 12z"
      />
      <path
        fill="#252525"
        fillRule="nonzero"
        d="M11.672 2.393A.875.875 0 1 1 12.328.77a8.877 8.877 0 0 1 0 16.46.875.875
        0 1 1-.656-1.623 7.127 7.127 0 0 0 0-13.214z"
      />
      <path
        fill="#252525"
        fillRule="nonzero"
        d="M11.416 6.298a.875.875 0 1 1 1.168-1.304A5.363 5.363 0 0 1 14.375 9c0
        1.549-.66 2.993-1.791 4.006a.875.875 0 0 1-1.168-1.304A3.613 3.613 0 0 0
        12.625 9a3.613 3.613 0 0 0-1.209-2.702z"
      />
    </g>
  </SvgIcon>
);

export default NavAudioHigh;



// WEBPACK FOOTER //
// ./src/js/icons/NavAudioHigh.jsx